import React from "react";
import CryptoFuturesCoins from "../../Common/CryptoFuturesCoins/CryptoFuturesCoins";
import SidebarOption from "./SidebarOption";

const DropdownOptions = ({
  options,
  onSubOptionClick,
  activeSubOptionIndex,
  className = "",
  isOpen = false,
  isScrollable = false,
}) => {
  const dropdownClassName = [
    "dropdown-options",
    className,
    isOpen ? "is-dropdown-open" : "is-dropdown-closed",
    isScrollable ? "is-scrollable-dropdown" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={dropdownClassName} aria-hidden={!isOpen}>
      <div className="dropdown-options-inner">
        {options.map((option, optionIndex) =>
          option.text === "Crypto Futures" ? (
            <CryptoFuturesCoins key={optionIndex} />
          ) : (
            <div key={optionIndex}>
              <SidebarOption
                {...option}
                onClick={(event) =>
                  onSubOptionClick(optionIndex, option.sidebarUrl, option, event)
                }
                isActive={option.sidebarUrl === activeSubOptionIndex}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default DropdownOptions;
